document.addEventListener('DOMContentLoaded', () => {
  const banner = document.getElementById('video-banner');
  if (!banner) return;

  const video = banner.querySelector('video');
  const playBtn = banner.querySelector('.video-toggle-btn');
  const soundBtn = document.getElementById('video-sound-toggle');

  if (!video) return;

  /* -------------------------
     PLAY / PAUSE LOGIC
  -------------------------- */

  function toggleVideo() {
    if (video.paused) {
      video.play();
      if (playBtn) playBtn.classList.remove('paused');
    } else {
      video.pause();
      if (playBtn) playBtn.classList.add('paused');
    }
  }

  if (playBtn) {
    banner.addEventListener('click', (e) => {
      if (e.target.closest('.video-toggle-btn') || e.target.closest('#video-sound-toggle')) return;
      toggleVideo();
    });

    playBtn.addEventListener('click', toggleVideo);

    document.addEventListener('keydown', (e) => {
      if (e.code === 'Space') {
        e.preventDefault();
        toggleVideo();
      }
    });
  }

  /* -------------------------
     SOUND TOGGLE LOGIC
  -------------------------- */

  if (soundBtn) {
    // Must start muted for autoplay to work
    video.muted = true;
    video.volume = 1;

    function updateSoundIcon() {
      soundBtn.textContent = video.muted ? "🔊" : "🔇";
    }

    updateSoundIcon();

    soundBtn.addEventListener('click', (e) => {
      e.stopPropagation(); // prevent triggering play toggle
      video.muted = !video.muted;
      updateSoundIcon();
    });
  }
});